import { Spinner } from "components";

import React, { useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router";
import Axios from "axios";
import { API_GATEWAY2 } from "aws-exports";
import ShopContext from "context/ShopContext";

function addDays (date, days) {
  const copy = new Date(Number(date));
  copy.setDate(date.getDate() + days);
  return copy.getTime();
}

export default function InvitationScreen (props) {
  const history = useHistory();
  const { id } = useParams();
  const { AppLocalStorage } = useContext(ShopContext)
  const fetchInvitation = async () => {
    try {
      //HIT API
      const { data } = await Axios({
        method: "get",
        url: `${API_GATEWAY2}/invitations`,
        params: {
          id
        }
      });
      if (data.redirect) {
        AppLocalStorage.setItem(
          "invitation_id",
          JSON.stringify({
            id,
            expiry: addDays(new Date(), 7)
          })
        );
        window.location.href = `${data.redirect.indexOf("https://") === 0 ? "" : "https://"
          }${data.redirect}`;
      } else {
        throw new Error("invitation not found");
      }
    } catch (error) {
      history.push("/login");
    }
  };

  useEffect(() => {
    // get the invitation
    fetchInvitation();
  }, []);

  return <Spinner text="Please Wait" />;
}
